import * as React from 'react';
import { clsx } from 'clsx';

import * as styles from './CollapsedButton.css';

type TButtonProps = Omit<
  React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
  'type'
>;

export interface ICollapsedButtonProps extends TButtonProps {
  opened: boolean;
  openedContent?: React.ReactNode;
  closedContent?: React.ReactNode;
  onClick(): void;
}

export class CollapsedButton extends React.Component<ICollapsedButtonProps> {
  public static defaultProps = {
    openedContent: 'Свернуть',
    closedContent: 'Читать больше',
  };

  public render() {
    const { opened, openedContent, closedContent, onClick, ...buttonProps } = this.props;

    return (
      <button
        {...buttonProps}
        type="button"
        className={clsx(styles['toggle-btn'], opened && styles['toggle-btn--close'], buttonProps.className)}
        onClick={onClick}
      >
        {opened ? openedContent : closedContent}
      </button>
    );
  }
}
